import { useLiveDemo } from "@/hooks/useLiveDemo";

export function useGetPath() {
  const isLiveDemo = useLiveDemo();

  const getPath = (url?: string) => {
    if (!url) return '/';
    if (url.startsWith('http') || url.startsWith('mailto:')) return url;
    if (isLiveDemo) {
      // Keep anonymous demo browsing inside the public /live-demo namespace.
      // Authenticated users are not in live-demo mode, even if auth returned
      // them to a /live-demo URL, so generated app navigation should use the
      // normal authenticated routes.
      // Avoid double slashes
      if (url.startsWith('/login')) return url;
      if (url.startsWith('/live-demo')) return url;
      return '/live-demo' + (url.startsWith('/') ? url : '/' + url);
    }
    return url;
  };
  return getPath;
}
